import { createContext, useContext } from 'react'

import { PanelDataProvider } from './dataProvider'

interface IValue {
  open: boolean
  setOpen: (open: boolean) => void
  setContent: (content: React.ReactNode) => void
}

interface Props {
  open: boolean
  setOpen: (open: boolean) => void
  setContent: (content: React.ReactNode) => void
  children: React.ReactNode
}

const PanelProviderContext = createContext<IValue | undefined>(undefined)

export const PanelProvider: React.FC<Props> = ({ open, setOpen, setContent, children }) => {
  return (
    <PanelProviderContext.Provider value={{ open, setOpen, setContent }}>
      <PanelDataProvider>{children}</PanelDataProvider>
    </PanelProviderContext.Provider>
  )
}

export const usePanel = () => {
  const context = useContext(PanelProviderContext)
  if (context === undefined) {
    throw new Error('usePanel must be used within a PanelProvider')
  }
  return context
}
